import { render, staticRenderFns } from "./AssistSuccessDialog.vue?vue&type=template&id=1b15ff88&scoped=true"
import script from "./AssistSuccessDialog.vue?vue&type=script&lang=js"
export * from "./AssistSuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./AssistSuccessDialog.vue?vue&type=style&index=0&id=1b15ff88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3_jycg54st5iyjtzg36i6kaokove/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b15ff88",
  null
  
)

export default component.exports